import * as angular from "angular";

angular
  .module('bringoz.admin.pricePlan')
  .filter('padding', padding);

function padding() {
  return function paddingFilter(n, len) {
    let num: any = parseInt(n, 10);
    len = parseInt(len, 10);
    if (isNaN(num) || isNaN(len)) {
      return n;
    }
    num = '' + num;
    while (num.length < len) {
      num = '0' + num;
    }
    return num;
  }
}
